import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import {
  IInviteActivationCompletePayload,
  IInviteActivationStartPayload,
} from '../entities/invite-activation.interface';

@Injectable({ providedIn: 'root' })
export class InviteActivationService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl;

  public start(payload: IInviteActivationStartPayload): Observable<unknown> {
    return this.http.post<unknown>(
      `${this.apiUrl.userService}/InviteActivation/Start`,
      payload,
      { withCredentials: false }
    );
  }

  public complete(payload: IInviteActivationCompletePayload): Observable<unknown> {
    return this.http.post<unknown>(
      `${this.apiUrl.userService}/InviteActivation/Complete`,
      payload,
      { withCredentials: false }
    );
  }
}
